export const STATUS_WAITING = "STATUS_WAITING"
export const STATUS_ANALYSIS = "STATUS_ANALYSIS"
export const STATUS_APPROVED = "STATUS_APPROVED"
export const STATUS_REJECTED = "STATUS_REJECTED"
